<template>
	<v-col class="pa-0" cols="12">
		<v-card elevation="1" class="background-2 round-card">
			<v-card-title class="pa-3">
				<p :class="{'pl-3': $vuetify.breakpoint.smAndUp, 'pl-2': $vuetify.breakpoint.smAndDown}">Casella PEC invio massivo (campagne)</p>
				<v-spacer></v-spacer>
			</v-card-title>
			<v-divider></v-divider>
			<v-container class="pa-0 pt-4" fluid>
				<!-- SMTP Section -->
				<v-row class="pa-4">
					<v-col cols="12" class="pt-0 pb-0 px-4">
						<h3 class="pb-2">SMTP</h3>
					</v-col>
					<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
						<v-text-field
							type="text"
							label="Host"
							v-model="settings['mail_host']"
							:error-messages="errors.collect('Host')"
							:data-vv-name="'Host'"
							outlined
							dense
						></v-text-field>
					</v-col>
					<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
						<v-text-field
							type="number"
							label="Porta"
							v-model.number="settings['mail_port']"
							:error-messages="errors.collect('Porta')"
							:data-vv-name="'Porta'"
							outlined
							dense
						></v-text-field>
					</v-col>
					<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
						<v-text-field
							type="text"
							label="Nome utente"
							v-model="settings['mail_username']"
							:error-messages="errors.collect('Nome utente')"
							:data-vv-name="'Nome utente'"
							outlined
							dense
						></v-text-field>
					</v-col>
					<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
						<v-text-field
							label="Password"
							v-model="settings['mail_password']"
							:error-messages="errors.collect('Password')"
							:data-vv-name="'Password'"
							outlined
							dense
							:append-icon="e1 ? 'visibility' : 'visibility_off'"
							@click:append="() => {e1 = !e1}"
							:type="!e1 ? 'password' : 'text'"
						></v-text-field>
					</v-col>
					<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
						<v-select
							label="Crittografia"
							:items="[
								{
									'text': 'SSL',
									'value': 'ssl'
								},
								{
									'text': 'TLS',
									'value': 'tls'
								},
								{
									'text': 'Nessuna',
									'value': null
								}
							]"
							v-model="settings['mail_encryption']"
							:error-messages="errors.collect('Crittografia')"
							:data-vv-name="'Crittografia'"
							:menu-props="{'offset-y': true}"
							outlined
							dense
						></v-select>
					</v-col>
					<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
						<v-text-field
							type="text"
							label="Mail Mittente"
							v-model="settings['mail_from_address']"
							:error-messages="errors.collect('Mail Mittente')"
							:data-vv-name="'Mail Mittente'"
							outlined
							dense
						></v-text-field>
					</v-col>
					<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
						<v-text-field
							type="text"
							label="Nome Mittente"
							v-model="settings['mail_from_name']"
							:error-messages="errors.collect('Nome Mittente')"
							:data-vv-name="'Nome Mittente'"
							outlined
							dense
						></v-text-field>
					</v-col>
				</v-row>
			</v-container>
			<v-divider></v-divider>

			<!-- IMAP Section -->
			<v-container class="pa-0 pt-4" fluid>
				<v-row class="pa-4">
					<v-col cols="12" class="pt-0 pb-0 px-4">
						<h3 class="pb-2">IMAP (ricevute)</h3>
					</v-col>
					<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
						<v-text-field
							type="text"
							label="Host"
							v-model="settings['imap_host']"
							:error-messages="errors.collect('IMAP Host')"
							:data-vv-name="'IMAP Host'"
							outlined
							dense
						></v-text-field>
					</v-col>
					<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
						<v-text-field
							type="number"
							label="Porta"
							placeholder="993"
							v-model.number="settings['imap_port']"
							:error-messages="errors.collect('IMAP Porta')"
							:data-vv-name="'IMAP Porta'"
							outlined
							dense
						></v-text-field>
					</v-col>
					<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
						<v-select
							label="Crittografia"
							:items="[
								{
									'text': 'SSL',
									'value': 'ssl'
								},
								{
									'text': 'TLS',
									'value': 'tls'
								},
								{
									'text': 'Nessuna',
									'value': null
								}
							]"
							v-model="settings['imap_encryption']"
							:error-messages="errors.collect('IMAP Crittografia')"
							:data-vv-name="'IMAP Crittografia'"
							:menu-props="{'offset-y': true}"
							outlined
							dense
						></v-select>
					</v-col>
					<v-col cols="12" class="pt-3 pb-0 px-4">
						<small class="caption grey--text">Usata per leggere le ricevute di accettazione e consegna. Credenziali: le stesse della sezione SMTP</small>
					</v-col>
				</v-row>
			</v-container>
			<v-divider></v-divider>

			<!-- Password Expiry Section -->
			<v-container class="pa-0 pt-4" fluid>
				<v-row class="pa-4">
					<v-col cols="12" class="pt-0 pb-0 px-4">
						<h3 class="pb-2">Scadenza password</h3>
					</v-col>
					<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
						<g-m-h-date-picker
							v-model="settings['password_expires_at']"
							label="Scadenza password"
							:dense="true"
							:clearable="true"
						></g-m-h-date-picker>
					</v-col>
					<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
						<v-text-field
							type="number"
							label="Giorni di preavviso"
							hint="Default 7"
							v-model.number="settings['password_expiry_reminder_days']"
							:error-messages="errors.collect('Giorni di preavviso')"
							:data-vv-name="'Giorni di preavviso'"
							outlined
							dense
						></v-text-field>
					</v-col>
					<v-col class="pt-0 pb-0 px-4" cols="12">
						<v-autocomplete
							v-model="settings['password_expiry_notify_users']"
							:items="usersList"
							item-text="value"
							item-value="id"
							chips
							label="Utenti da notificare"
							hint="Riceveranno una notifica al preavviso e alla scadenza"
							persistent-hint
							multiple
							outlined
							clearable
							dense
							:menu-props="{maxHeight:'200', nudgeBottom: 3}">
							<template v-slot:selection="{ item }">
								<v-chip small>
									<v-avatar v-if="item.avatar" left>
										<v-img :src="item.avatar"></v-img>
									</v-avatar>
									<v-avatar v-else color="primary" left size="24">
										<span class="white--text caption">{{ item.value.charAt(0) }}</span>
									</v-avatar>
									<span>{{ item.value }}</span>
								</v-chip>
							</template>
							<template v-slot:item="{ item }">
								<v-list-item-avatar v-if="item.avatar">
									<v-img :src="item.avatar"></v-img>
								</v-list-item-avatar>
								<v-list-item-avatar v-else color="primary">
									<span class="white--text">{{ item.value.charAt(0) }}</span>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title>{{ item.value }}</v-list-item-title>
									<v-list-item-subtitle>{{ item.email }}</v-list-item-subtitle>
								</v-list-item-content>
							</template>
						</v-autocomplete>
					</v-col>
				</v-row>
			</v-container>
			<v-divider></v-divider>

			<!-- Send Limits Section -->
			<v-container class="pa-0 pt-4" fluid>
				<v-row class="pa-4">
					<v-col cols="12" class="pt-0 pb-0 px-4">
						<h3 class="pb-2">Limiti di invio</h3>
					</v-col>
					<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
						<v-text-field
							type="number"
							label="Secondi minimi tra un invio e l'altro"
							hint="Default 60"
							v-model.number="settings['send_interval_seconds']"
							:error-messages="errors.collect('Intervallo invio')"
							:data-vv-name="'Intervallo invio'"
							outlined
							dense
						></v-text-field>
					</v-col>
					<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
						<v-text-field
							type="number"
							label="Massimo invii al giorno"
							hint="Default 100"
							v-model.number="settings['daily_cap']"
							:error-messages="errors.collect('Daily Cap')"
							:data-vv-name="'Daily Cap'"
							outlined
							dense
						></v-text-field>
					</v-col>
					<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
						<v-text-field
							type="number"
							label="Dimensione massima messaggio (MB)"
							hint="Allegati inclusi. Default 25"
							v-model.number="settings['max_message_mb']"
							:error-messages="errors.collect('Max Message MB')"
							:data-vv-name="'Max Message MB'"
							outlined
							dense
						></v-text-field>
					</v-col>
				</v-row>
			</v-container>
			<v-divider></v-divider>
			<v-card-actions class="pr-4">
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.native="saveSettings">Salva</v-btn>
			</v-card-actions>
		</v-card>
	</v-col>
</template>

<script>

	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'
	import GMHDatePicker from '@/components/common/GMHDatePicker'

	export default {
		name: 'pec-massive-smtp',
		mixins: [SettingsOptionsMixin],
		components: {
			GMHDatePicker
		},
		props: {},
		data() {
			return {
				model: 'pec_massive',
				settings: {
					'mail_host': '',
					'mail_port': '',
					'mail_username': '',
					'mail_password': '',
					'mail_encryption': '',
					'mail_from_address': '',
					'mail_from_name': '',
					'imap_host': '',
					'imap_port': '',
					'imap_encryption': '',
					'send_interval_seconds': '',
					'daily_cap': '',
					'max_message_mb': '',
					'password_expires_at': '',
					'password_expiry_reminder_days': '',
					'password_expiry_notify_users': []
				},
				e1: false
			}
		},
		computed: {
			usersList() {
				return this.$store.getters.usersSeq
			}
		},
	}
</script>

<style scoped>

</style>
